import axios from "axios";
import { useEffect, useState } from "react";
import { getEmailFromToken, getEmail } from "../helper/helper";
axios.defaults.baseURL = process.env.REACT_APP_SERVER_DOMAIN;

export default function useFetch(query) {
  const [getData, setData] = useState({
    isLoading: false,
    apiData: {},
    status: null,
    serverError: null,
  });

useEffect(() => {
  const fetchData = async () => {
    try {
      setData(prev => ({ ...prev, isLoading: true }));

      let endpoint;

      if (!query) {
        // Get email from token
        const email = await getEmailFromToken();
        if (!email) {
          throw new Error("Email not found in token");
        }

        // Optional: fetch user details using that email if you need more info
        const { data: userData } = await getEmail({ email });
        if (!userData) {
          throw new Error("User not found");
        }

        endpoint = `/api/user/${email}`;
      } else {
        endpoint = `/api/${query}`;
      }

      const { data, status } = await axios.get(endpoint);

      if (status === 200) {
        setData(prev => ({ ...prev, apiData: data, status }));
      }
    } catch (error) {
      setData(prev => ({ ...prev, serverError: error }));
    } finally {
      setData(prev => ({ ...prev, isLoading: false }));
    }
  };

  fetchData();
}, [query]);

  return [getData, setData];
}
